/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  BlockStack,
  Button,
  Card,
  FormLayout,
  Frame,
  Icon,
  Page,
  Text,
  TextField,
  Toast,
} from "@shopify/polaris";
import { ViewIcon, HideIcon } from "@shopify/polaris-icons";
import { Controller, useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { usePostCreateNewPasswordMutation } from "../store/store/slices/UsersRTK";
import { useCallback, useEffect, useState } from "react";

const ForgotPassword = () => {
  const location = useLocation();
  const navigateTo = useNavigate();
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [passwordsMacthed, setPasswordsMatched] = useState<boolean>(true);
  const [createNewPassword, { isError, error, isLoading, isSuccess }] =
    usePostCreateNewPasswordMutation();
  const hash = new URLSearchParams(useLocation().search).get("hash");
  const _id = new URLSearchParams(useLocation().search).get("id");
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [active, setActive] = useState(false);
  const [theme, setTheme] = useState(localStorage.getItem("theme") || "light");
  const toggleActive = useCallback(() => setActive((active) => !active), []);

  const toastMarkup =
    active && isSuccess ? (
      <Toast
        content="Password has been changed"
        onDismiss={toggleActive}
        duration={2000}
      />
    ) : null;
  useEffect(() => {
    if (isSuccess) {
      setActive(isSuccess);
      setTimeout(() => {
        navigateTo("/login");
      }, 2000);
    }
  }, [isLoading, isError, error]);
  const onCreateNewPasswordHandler = async (formData: any) => {
    if (formData.password !== formData.confirm_password) {
      setPasswordsMatched(false);
      return;
    }
    setPasswordsMatched(true);
    await createNewPassword({
      ...formData,
      hash,
      email: location?.state?.email,
      _id,
    });
  };
  const onShowPasswordHandler = () => {
    setShowPassword((prev) => !prev);
  };
  return (
    <Frame>
      <Page title="Create password" narrowWidth>
        <BlockStack gap={"300"}>
          {toastMarkup}

          <Card>
            <BlockStack gap={"300"}>
              <FormLayout>
                <Controller
                  name="password"
                  rules={{ required: "Password is required" }}
                  control={control}
                  render={({ field }) => (
                    <div style={{ position: "relative" }}>
                      <span
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "20px",
                          padding: "0",
                          position: "absolute",
                          right: "5px",
                          top: "30px",
                          zIndex: "100000",
                          cursor: "pointer",
                        }}
                        onClick={onShowPasswordHandler}
                      >
                        <Icon source={!showPassword ? ViewIcon : HideIcon} />
                      </span>
                      <TextField
                        autoComplete="Off"
                        label="Enter new password"
                        type={showPassword ? "text" : "password"}
                        error={errors.password && "Password is required"}
                        helpText={
                          !errors.password && (
                            <Text
                              as="p"
                              tone="critical"
                              variant="bodyXs"
                              alignment="end"
                            >
                              should be strong
                            </Text>
                          )
                        }
                        {...field}
                      ></TextField>
                    </div>
                  )}
                />
              </FormLayout>
              <FormLayout>
                <Controller
                  name="confirm_password"
                  rules={{ required: "Password is required" }}
                  control={control}
                  render={({ field }) => (
                    <div style={{ position: "relative" }}>
                      <span
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "20px",
                          padding: "0",
                          position: "absolute",
                          right: "5px",
                          top: "30px",
                          zIndex: "100000",
                          cursor: "pointer",
                        }}
                        onClick={onShowPasswordHandler}
                      >
                        <Icon source={!showPassword ? ViewIcon : HideIcon} />
                      </span>
                      <TextField
                        autoComplete="Off"
                        label="Enter new password"
                        type={showPassword ? "text" : "password"}
                        error={
                          errors.confirm_password && "Password is required"
                        }
                        helpText={
                          !errors.confirm_password && (
                            <Text
                              as="p"
                              tone="critical"
                              variant="bodyXs"
                              alignment="end"
                            >
                              should match password
                            </Text>
                          )
                        }
                        {...field}
                      ></TextField>
                    </div>
                  )}
                />
              </FormLayout>
              {isError && (
                <Text as="p" tone="critical">
                  {error?.data?.errors[0].msg}
                </Text>
              )}
              {!passwordsMacthed && (
                <Text as="p" tone="critical">
                  Password and confirm password must be same
                </Text>
              )}

              <div
                style={{
                  display: "flex",
                  justifyContent: "end",
                  alignItems: "center",
                }}
              >
                <Button
                  variant={theme === "dark" ? "secondary" : "primary"}
                  onClick={handleSubmit(onCreateNewPasswordHandler)}
                  loading={isLoading}
                  disabled={isLoading}
                >
                  Create new password
                </Button>
              </div>
            </BlockStack>
          </Card>
        </BlockStack>
      </Page>
    </Frame>
  );
};

export default ForgotPassword;
